import styled from 'styled-components';

export const Spinner = styled.div`
  width: 100%;
  text-align: center;
  & path {
    fill: ${props => props.isLight ? props.theme.loading.light : props.theme.loading.dark};
  }
`;



// WEBPACK FOOTER //
// ./components/Loading/Loading.style.js